import axios from 'axios'
import helpers from "@/services/helpers";
export default {
  namespaced: true,
  state: {
    werehouse: null,
    werehouseSelect: null
  },
  mutations: {
    SET_WEREHOUSES(state, payload) {
      state.werehouse = payload.data
    },
    SET_WEREHOUSES_CREATE(state, payload) {
      state.werehouse.data.unshift(payload.data)
    },
    SET_WAREHOUSES_DESTROY(state, payload) {
      state.werehouse.data = state.werehouse.data.filter(item => item.id !== payload)
    },
    SET_WEREHOUSES_SELECT(state, payload){
      state.werehouseSelect = payload.data
    }
  },
  getters: {
    warehouses: state => state.werehouse,
    warehouseSelect: state => state.werehouseSelect
  },
  actions: {
    async getWarehouses({ commit }, vm) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        let url = null
        url = `?paginated=true${vm.currentPage ? '&page=' + vm.currentPage : ''}${vm.perPage ? '&per_page=' + vm.perPage : ''}${vm.company_id ? '&company_id=' + vm.company_id : ''}`
        const res = await axios.get(`/api/warehouses${url ? url : ''}`);
        commit("SET_WEREHOUSES", res.data);
        return res.data;
      } catch (error) {
        
        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },
    async getWarehousesSelect({ commit }, payload) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        const res = await axios.get(`/api/warehouses?company_id=${payload}`);
        commit("SET_WEREHOUSES_SELECT", res.data);
        return res.data;
      } catch (error) {
        
        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },
    async getWarehousesByProducts({ commit }, payload) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        const res = await axios.get(`/api/warehouses-by-product?product_id=${payload}`);
        return res.data;
      } catch (error) {
        
        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },
    async createWerehouse({ commit, dispatch }, payload) {
      commit('config/SET_OVERLAY', true, { root: true })
      console.log(payload)
      try {
        if (payload.id) {
          const res = await axios.put(`/api/warehouses/${payload.id}`, payload);
          return res.data;
        } else {
          const res = await axios.post('/api/warehouses', payload)
          return res.data
        }
      } catch (error) {
        console.error(error)
        throw error
      } finally {
        dispatch('getWarehouses', { currentPage: 1, perPage: 10, company_id : payload.company_id })
        commit('config/SET_OVERLAY', false, { root: true })
      }
    },
    async delete({ commit }, id) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        const res = await axios.delete(`api/warehouses/${id}`);
        res ? commit("SET_WAREHOUSES_DESTROY", id) : ''
        return res.data;
      } catch (error) {
        
        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    }
  },
}
